import { Routes } from '@angular/router';
import { permissionGuard } from '../../core/auth/permission.guard';
import { GRC_PLATFORM_ENTITLEMENT } from './grc-form.models';
import { GRC_INTEGRATION_ROUTES } from './integration/grc-integration.routes';

const adminScope = { requiredScopes: ['admin'] as const };

export const GRC_ROUTES: Routes = [
  ...GRC_INTEGRATION_ROUTES,
  {
    path: 'grc/settings',
    loadComponent: () => import('./grc-settings.component').then(m => m.GrcSettingsComponent),
    canActivate: [permissionGuard],
    data: {
      requiredPermission: 'grc.config.read',
      requiredEntitlement: GRC_PLATFORM_ENTITLEMENT,
      ...adminScope
    }
  }
];
